// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3FoXS","validationTips":"StatementDescriptor_validationTips__2NoWE"};